<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SkillCreate from '../../../../skills/components/SkillCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'skills',
    }
})
</script>

<template>
  <SkillCreate />
</template>